import React from "react";
import Link from "next/link";

import { apiPath } from "shared/helpers/apiPath";
import { applicationRoutes } from "shared/helpers/applicationRouting";
import useRequest from "@/helpers/useRequest";
import SectionHeading from "@/components/SectionHeading";
import SkeletonLoader from "@/components/SkeletonLoader";
import { PopularArticlesInterface } from "@/components/PopularArticles/PopularArticles.interface";
import Typography from "@/components/Typography";
import Avatar from "@/components/Avatar";

import styles from "./PopularArticles.module.scss";

export const PopularArticles: React.FC<PopularArticlesInterface> = ({
  slug,
  className
}) => {
  const { data } = useRequest(apiPath.POPULAR_ARTICLES(slug));

  return (
    <div className={className}>
      <SectionHeading title="Popularne" className={styles.heading}/>
      <ul className={styles["articles-list"]}>
        {data ? (
          data?.map((article) => (
            <li className={styles.article} key={article.id}>
              <>
                <Link
                  href={`${applicationRoutes.ARTICLE}[slug]`}
                  as={applicationRoutes.ARTICLE + article.slug}
                >
                  <a className={styles.link}>{article.title}</a>
                </Link>
                <div className={styles.info}>
                  {article.author && (
                    <Link
                      key={article.author.id}
                      href={{
                        pathname: `${applicationRoutes.AUTHOR}[slug]`,
                        query: { from: "Artykuł" },
                      }}
                      as={applicationRoutes.AUTHOR + article.author.slug}
                    >
                      <a className={styles.author}>
                        <Avatar
                          key={article.author.id}
                          src={article.author?.avatar?.url}
                          alt={article.author.name}
                          className={styles.avatar}
                        />
                        <Typography
                          variant="small"
                          component="p"
                          className={styles.name}
                        >
                          {article.author.name}
                        </Typography>
                      </a>
                    </Link>
                  )}
                </div>
              </>
            </li>
          ))
        ) : (
          <SkeletonLoader height={80} />
        )}
      </ul>
    </div>
  );
};

export default PopularArticles;
